import React from 'react';
import { Close, CheckCircle } from '@mui/icons-material';

const WithdrawSuccessModal = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
                <div className="text-center">
                    <div className="flex justify-center mb-6">
                        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center">
                            <CheckCircle className="text-amber-600 text-5xl" />
                        </div>
                    </div>

                    <h3 className="text-2xl font-bold text-amber-900 mb-3">
                        Demande De Retrait confirmé !
                    </h3>
                    <p className="text-gray-600 mb-8">
                        Votre demande de retrait a bien été envoyée. Vous serez notifié d'ici peu.
                    </p>

                    <button
                        onClick={onClose}
                        className="w-full bg-amber-500 text-white py-3 rounded-xl font-semibold hover:bg-amber-600 transition-all"
                    >
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WithdrawSuccessModal;










